import { logger } from "@/lib/logger";
import type { User } from "@/models/user";
import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface AuthState {
  user: User; // info user
  // token: string | null; //token user
  role: number | null; // role. ex: user, admin...
  loading: boolean; // auth loading state
}

const initialState: AuthState = {
  user: null,
  // token: null,
  role: null,
  loading: false
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    // set loading true when auth request starts
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    // push info to store (token, user, role). use when login success
    login: (state, action: PayloadAction<{ user: User; role: number }>) => {
      // state.token = action.payload.token;
      state.user = action.payload.user;
      // state.user.stUserGuid = state.user.id;
      state.user.id = action.payload.user.spUserGuid;
      state.role = action.payload.role;
      state.loading = false;
    },
    update: (state, action: PayloadAction<{ user: User }>) => {
      // Merge incoming partial profile into the existing auth user to avoid
      // accidentally removing auth-only fields (e.g. spUserGuid / stUserGuid)
      // when payload contains only profile fields.
      state.user = { ...(state.user || {}), ...(action.payload.user || {}) } as User;

      // Preserve/normalize auth ID fields:
      // - Prefer spUserGuid from the incoming payload when present.
      // - Otherwise keep the existing spUserGuid.
      const incomingSpUserGuid = (action.payload.user as any)?.spUserGuid;
      if (incomingSpUserGuid) {
        (state.user as any).spUserGuid = incomingSpUserGuid;
      }

      // Ensure state.user.id (used across the app) remains set to spUserGuid if available.
      (state.user as any).id = (state.user as any).spUserGuid || (state.user as any).id;

      state.loading = false;
    },
    // clear data when user logout
    logout: (state) => {
      logger.info("authReducer: logout action received, clearing user state");
      state.user = initialState.user;
      state.role = initialState.role;
      state.loading = false;
      // Side effects like router.replace should be in thunks or components, not reducers
    }
  }
});
export const { setLoading, login, update, logout } = authSlice.actions;

export default authSlice.reducer;
